import { createPage } from "@/createPage";
import { LandingScreen } from "@/GameInterface/LandingScreen";

createPage(LandingScreen, { public: true });
